import axios from "axios";
//http://localhost:8080
//${process.env.REACT_APP_BASIC_URL}

export const addNewsAPI = (data) =>
  axios
    .post(`${process.env.REACT_APP_BASIC_URL}/add-news`, data)
    .catch((error) => {
      console.error(error);
    });

export const getCompanies = () =>
  axios
    .get(`${process.env.REACT_APP_BASIC_URL}/get-new-spots`)
    .catch((error) => {
      console.error(error);
    });

export const saveCompanyAPI = (data) =>
  axios
    .post(`${process.env.REACT_APP_BASIC_URL}/add-spot`, data)
    .catch((error) => {
      console.error(error);
    });

export const downloadFile = (data) =>
  axios
    .post(`${process.env.REACT_APP_BASIC_URL}/download`, data)
    .catch((error) => {
      console.error(error);
    });

export const uploadFile = (data) =>
  axios
    .post(`${process.env.REACT_APP_BASIC_URL}/upload`, data)
    .catch((error) => {
      console.error(error);
    });

export const addSpot = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASIC_URL}/add-new-spot`, data)
    .catch((error) => {
      console.error(error);
    });
};

export const getSpotByTypeKeyAPI = (data) =>
  axios
    .get(`${process.env.REACT_APP_BASIC_URL}/get-spot-by-type-key`, {
      params: data,
    })
    .catch((error) => {
      console.error(error);
    });

export const getSpotsByPropValueAPI = (data) =>
  axios
    .get(`${process.env.REACT_APP_BASIC_URL}/get-spots-by-prop-value`, {
      params: data,
    })
    .catch((error) => {
      console.error(error);
    });

export const getSpotByName = (data) =>
  axios
    .get(`${process.env.REACT_APP_BASIC_URL}/get-spot-by-name`, {
      params: data,
    })
    .catch((error) => {
      console.error(error);
    });

export const getNewsByKey = (data) =>
  axios
    .get(`${process.env.REACT_APP_BASIC_URL}/get-news-by-key`, { params: data })
    .catch((error) => {
      console.error(error);
    });

export const signup = (data) =>
  axios
    .post(`${process.env.REACT_APP_BASIC_URL}/signup`, data)
    .catch((error) => {
      console.error(error);
    });

export const login = (data) =>
  axios
    .post(`${process.env.REACT_APP_BASIC_URL}/login`, data)
    .catch((error) => {
      console.error(error);
    });

export const getNews = (data) =>
  axios
    .get(`${process.env.REACT_APP_BASIC_URL}/get-all-news`, {
      params: data,
    })
    .catch((error) => {
      console.error(error);
    });

export const updataSpotAPI = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASIC_URL}/update-spot`, {
      data,
    })
    .catch((error) => {
      console.error(error);
    });
};

export const putSpotAPI = (
  data, ///We don't use yet
) =>
  axios
    .put(`${process.env.REACT_APP_BASIC_URL}/put-spot`, data)
    .catch((error) => {
      console.error(error);
    });

export const saveCategoriesAPI = (data) =>
  axios
    .post(`${process.env.REACT_APP_BASIC_URL}/add-categories-text`, data)
    .catch((error) => {
      console.error(error);
    });

export const getCategoryByTypeField = (data) =>
  axios
    .get(
      `${process.env.REACT_APP_BASIC_URL}/get-categories-text-by-type-field`,
      {
        params: data.data,
      },
    )
    .catch((error) => {
      console.error(error);
    });

export const tokenAuthServices = (token, isAdmin) =>
  axios
    .get(`${process.env.REACT_APP_BASIC_URL}/tokenAuthServices`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
      params: {
        isAdmin: true,
      },
    })
    .catch((error) => console.error(error));

export const savePremiumPlanAPI = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASIC_URL}/add-premium-plan`, data)
    .catch((error) => {
      console.error(error);
    });
};
export const getOnePremiumPLanByName = (data) => {
  return axios
    .get(`${process.env.REACT_APP_BASIC_URL}/get-premium-plan-by-name`, {
      params: data.data,
    })
    .catch((error) => {
      console.error(error);
    });
};

export const updateUserAPI = (data) =>
  axios
    .post(`${process.env.REACT_APP_BASIC_URL}/update-user`, data)
    .catch((error) => {
      console.error(error);
    });

export const getUserArticlesAPI = () => {
  const token = localStorage.getItem("token_user");
  return axios
    .get(`${process.env.REACT_APP_BASIC_URL}/get-user-articles`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .catch((error) => {
      console.error(error);
    });
};

export const reviewUserArticleAPI = (data) => {
  const token = localStorage.getItem("token_user");
  return axios
    .post(`${process.env.REACT_APP_BASIC_URL}/review-user-article`, data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .catch((error) => {
      console.error(error);
    });
};

